import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'BASE_DATA_CAR_MODEL_LIBRARY',
    icon: 'menu-car-models',
    label: '车型库',
    path: '/base-data/car-model-library',
  },
] satisfies Menu[];
